module.exports = {
  "wrap": {
    "width": "710",
    "height": "408"
  },
  "tColumn": {
    "flexDirection": "row",
    "flexWrap": "nowrap",
    "justifyContent": "space-around"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-52d79827!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-picker/index.vue
// module id = 477
// module chunks = 0 1